<template>
    <div class="setup-system-prompt-summary">
        <ParameterConfiguredBadge :configured="isConfigured" />

        <div class="mt-1.5 space-y-0.5">
            <div
                v-for="row in rows"
                :key="row.label"
                class="flex items-baseline gap-1.5"
            >
                <span class="text-main-xs font-medium shrink-0">
                    {{ row.label }}:
                </span>
                <span
                    class="text-main-xs text-gray-500 truncate"
                    :title="row.text"
                >
                    {{ row.text || '—' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ParameterConfiguredBadge
    from '@/components/RedesignComponents/Widgets/Parameters/ParameterConfiguredBadge.vue'
import { validatePromptsConfig } from '@/composables/usePromptsValidation'
import { WidgetConfig } from '@/types/dashboard'
import i18n from '@/i18n'

const props = defineProps<{
    value: WidgetConfig
}>()

const isConfigured = computed(() => validatePromptsConfig(props.value))

/* A prompt is a markdown body, so its line breaks have to collapse before one row can ellipsis it */
function toSingleLine (text: unknown) {
    return String(text ?? '').replace(/\s+/g, ' ').trim()
}

const rows = computed(() => {
    const valueJson = props.value.WidgetParameterValueJson

    return [
        {
            label: String(i18n.t('widget.aiInstructions.customize.systemPrompt')),
            text: toSingleLine(valueJson?.system)
        },
        {
            label: String(i18n.t('widget.aiInstructions.customize.userPrompt')),
            text: toSingleLine(valueJson?.user)
        }
    ]
})
</script>
